// extracted by mini-css-extract-plugin
export default {"main":"StockSliderContent_main__fLQMa","info":"StockSliderContent_info__Zo5No","header":"StockSliderContent_header__uzSg3"};